import React from 'react'
import {
    Box,
    Grid,
    GridItem,
    SimpleGrid
  } from '@chakra-ui/react';
import { useOutletContext } from "react-router-dom"

import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../Navigation/Navigation';


function MainPage() {
  const {
    state,
    onRouteChange,
    onFormTextChangeUpdate,
    onViewChapter,
    onDeleteChapter,
    onCreateChapter,
    onLogOut,
    onSaveChapterTitle,
    isAuthenticated
  } = useOutletContext()
      return (
        <>
        <Grid templateColumns="repeat(48, 1fr)" bg="#F5F3F0">
        <GridItem
          as="aside"
          colSpan="7" 
          minHeight="100vh"
          position="sticky"   // sidebar itself is pinned
          top="0"
          alignSelf="start" 
          minW="125px"
          bg="white"
          borderRight="1px solid"
          borderColor="#E4E4E7"
          pt="16px"
          
        >
        <Sidebar 
        state = {state}
        onRouteChange = {onRouteChange}
        onViewChapter = {onViewChapter}
        onDeleteChapter = {onDeleteChapter}
        onCreateChapter = {onCreateChapter}
        onSaveChapterTitle = {onSaveChapterTitle}
        onFormTextChangeUpdate = {onFormTextChangeUpdate}
        />
        </GridItem>
        <GridItem
        as="main"
        colSpan="41" 
        // p="10px"
        // bg="gray.30"
        >
        <Navigation
        state = {state}
        onRouteChange = {onRouteChange}
        onLogOut = {onLogOut}
        isAuthenticated={isAuthenticated}
        />
        <SimpleGrid p ="10px" minChildWidth = "250px">
        
        <Box  display="flex" alignItems={'center'} justifyContent={'center'}>
        
          
        
        </Box>
        
          
      
       
        </SimpleGrid>
        </GridItem>
        </Grid>
        </>
      )
    }

  

export default MainPage